import React, { useEffect, useState } from "react";
import { getMyCV } from "../../../api/apiServices";
import "./MyCV.css";
export const ViewCV = ({ member }) => {
	const [data, setData] = useState({
		pf_number: "",
		fullname: "",
		mobile_number: "",
		email: "",
		profession: "",
		curriculum_vitae: "",
	});

	useEffect(() => {
		member?.pfNumber &&
			getMyCV(member?.pfNumber).then((res) => {
				setData((prevData) => ({
					...prevData,
					pf_number: res.myCV?.pf_number,
					fullname: res.myCV?.fullname,
					mobile_number: res.myCV?.mobile_number,
					email: res.myCV?.email,
					profession: res.myCV?.profession,
					curriculum_vitae: res.myCV?.curriculum_vitae,
				}));
			});
	}, [member?.pfNumber]);

	const viewMyCV = (
		<>
			<div className="cv-container">
				<div className="cv-box">
					<a
						rel="noreferrer"
						target="_blank"
						href={`/uploads/CVs/${data.curriculum_vitae}`}
					>
						<h3 className="cv-title">
							<i className="fa fa-eye"></i>
							&nbsp;&nbsp; Click to View CV
						</h3>
					</a>
				</div>
				<div className="cv-box">
					<a
						rel="noreferrer"
						target="_blank"
						download={`${data.curriculum_vitae}`}
						href={`/uploads/CVs/${data.curriculum_vitae}`}
					>
						<h3 className="cv-title">
							<i className="fa fa-cloud-download"></i>
							&nbsp;&nbsp; Click to Download CV
						</h3>
					</a>
				</div>
			</div>
		</>
	);
	return (
		<>
			<section className="content-header">
				<h1>
					<i className="fas file"></i> View Curriculum Vitae
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>My Curriculum Vitae</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{viewMyCV}</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
